import ENDPOINT from "../shared/constants/endPoint";
const BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const CONFIG = {
  ssoLogin: `${BASE_URL}${ENDPOINT.ssoLogin}`,
  plantList: `${BASE_URL}${ENDPOINT.plantList}`,
  createUser: `${BASE_URL}${ENDPOINT.createUser}`,
  getUserRole: `${BASE_URL}${ENDPOINT.getUserRole}`,
  getUserList: `${BASE_URL}${ENDPOINT.getUserList}`,
  deleteUser: `${BASE_URL}${ENDPOINT.deleteUser}`,
  updateUser: `${BASE_URL}${ENDPOINT.updateUser}`,
  getUserid: `${BASE_URL}${ENDPOINT.getUserid}`,
  subTaskQues: `${BASE_URL}${ENDPOINT.subTaskQues}`,
  updateSubQues: `${BASE_URL}${ENDPOINT.updateSubQues}`,
  updateVLM: `${BASE_URL}${ENDPOINT.updateVLM}`,
  uploadFAQ: `${BASE_URL}${ENDPOINT.uploadFAQ}`,
  uploadBulkUser: `${BASE_URL}${ENDPOINT.uploadBulkUser}`,
  sectionWeightage: `${BASE_URL}${ENDPOINT.sectionWeightage}`,
  addPlant: `${BASE_URL}${ENDPOINT.addPlant}`,
};

export default CONFIG;
